<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="3" width="12" height="18" rx="1.5" stroke="currentColor" stroke-width="1.6"/>
<path d="M8 6.5h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
<path d="M8.5 11h.01M12 11h.01M15.5 11h.01M8.5 14h.01M12 14h.01M15.5 14h.01M8.5 17h.01M12 17h.01M15.5 17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>
</template>
